const BRTABLE_CONSTANTS = {
  ASC: 'asc',
  DESC: 'desc',
  NONE: '',
};
export default BRTABLE_CONSTANTS;
